import React from "react";

export const successMessage = (id, history, pathname = '', prevState) => {
    let splitPathName = pathname.split('/');
    splitPathName[3] = id;
    let joinedPath = splitPathName.join('/');
    return (
        <>
            <span style={{paddingRight: 5}}>Success: </span>
            <span style={{cursor: 'pointer', textDecoration: 'underline'}}
                  onClick={() => {
                      history.push({
                          pathname: joinedPath,
                          state: {prevState: prevState}
                      })
                  }}>{id}</span>
        </>
    )
};